import { useState } from "react";
import "./ProductShowcase.css";

import {
    FaArrowRight,
    FaCheckCircle
} from "react-icons/fa";

/* Images */

import flexible from "../../assets/images/products/Flexible.jpg";
import woven from "../../assets/images/products/wovenbag.jpg";
import hdpe from "../../assets/images/products/hdpeone.jpg";
import stretch from "../../assets/images/products/strech.jpg";
import shrink from "../../assets/images/products/shrink.jpg";
import pouch from "../../assets/images/products/pouches.jpg";
import garbage from "../../assets/images/products/garbage-bag-5-jpg.webp";
import drum from "../../assets/images/products/hdpeone.jpg";

function ProductShowcase() {

const products=[

{

id:1,

name:"Flexible Packaging",

category:"Flexible Solutions",

image:flexible,

description:"High-performance flexible packaging solutions designed for superior product protection, efficient storage and reliable transportation across industrial sectors.",

features:[
"Excellent barrier properties",
"Lightweight & durable",
"Custom sizes available",
"High-quality printing"
],

applications:[
"Food Industry",
"Chemical Industry",
"Agriculture",
"Industrial Packaging"
]

},

{

id:2,

name:"Woven Bags",

category:"Bulk Packaging",

image:woven,

description:"Strong woven polypropylene bags manufactured for heavy-duty storage and transportation applications.",

features:[
"High tensile strength",
"Reusable",
"Moisture resistant",
"Custom branding"
],

applications:[
"Fertilizers",
"Cement",
"Agriculture",
"Chemicals"
]

},

{

id:3,

name:"HDPE Containers",

category:"Rigid Packaging",

image:hdpe,

description:"Industrial HDPE containers offering reliable storage and transportation of liquids and chemicals.",

features:[
"Leak resistant",
"Chemical resistant",
"Heavy-duty construction",
"Multiple capacities"
],

applications:[
"Chemical",
"Lubricants",
"Industrial",
"Pharma"
]

},

{

id:4,

name:"Stretch Film",

category:"Protective Packaging",

image:stretch,

description:"Premium stretch films engineered for secure pallet wrapping and transportation stability.",

features:[
"High stretchability",
"Excellent cling",
"Tear resistant",
"Crystal clear"
],

applications:[
"Warehouse",
"Logistics",
"Manufacturing",
"Export"
]

},

{

id:5,

name:"Shrink Film",

category:"Protective Packaging",

image:shrink,

description:"High-quality shrink films designed for secure wrapping and tamper protection.",

features:[
"Superior shrink ratio",
"Excellent clarity",
"Strong sealing",
"Durable finish"
],

applications:[
"Retail",
"Food",
"Beverages",
"Industrial"
]

},

{

id:6,

name:"Packaging Pouches",

category:"Retail Packaging",

image:pouch,

description:"Custom laminated pouches combining attractive presentation with outstanding product protection.",

features:[
"Food grade",
"Custom printing",
"Multiple laminates",
"Excellent shelf appeal"
],

applications:[
"Food",
"Snacks",
"Spices",
"Retail"
]

},

{

id:7,

name:"Garbage Bags",

category:"Waste Management",

image:garbage,

description:"Heavy-duty garbage bags manufactured for industrial, commercial and institutional waste collection.",

features:[
"Tear resistant",
"Leak proof",
"Heavy load capacity",
"Available in multiple sizes"
],

applications:[
"Hospitals",
"Hotels",
"Industries",
"Municipal"
]

},

{

id:8,

name:"Plastic Drums",

category:"Industrial Storage",

image:drum,

description:"Durable plastic drums engineered for safe handling and storage of industrial liquids.",

features:[
"Leak proof",
"Food grade options",
"UV resistant",
"Heavy-duty body"
],

applications:[
"Oil",
"Paint",
"Chemical",
"Food Processing"
]

}

];

const [activeProduct,setActiveProduct]=useState(products[0]);

return (

  <section
  className="products-section"
  id="products"
  >
  
  <div className="container-custom">
  
  <div className="products-header">
  
  <span>
  
  OUR PRODUCT RANGE
  
  </span>
  
  <h2>
  
  Industrial Packaging Solutions
  Designed For Every Business Need
  
  </h2>
  
  <p>
  
  Browse our complete range of industrial packaging products.
  Select any product to explore its features, applications and
  packaging capabilities.
  
  </p>
  
  </div>
  
  <div className="products-layout">
  
  {/* ============================
  LEFT PANEL
  ============================ */}
  
  <div className="products-sidebar">
  
  {
  
  products.map((product)=>(
  
  <div
  
  key={product.id}
  
  className={`sidebar-card ${
  activeProduct.id===product.id
  ?
  "active"
  :
  ""
  }`}
  
  onClick={()=>setActiveProduct(product)}
  
  >
  
  <div className="sidebar-image">
  
  <img
  
  src={product.image}
  
  alt={product.name}
  
  />
  
  </div>
  
  <div className="sidebar-content">
  
  <h3>
  
  {product.name}
  
  </h3>
  
  <p>
  
  {product.category}
  
  </p>
  
  </div>
  
  <div className="sidebar-arrow">
  
  <FaArrowRight/>
  
  </div>
  
  </div>
  
  ))
  
  }
  
  </div>
  
  {/* ============================
  RIGHT PANEL
  ============================ */}
  
  <div
  className="product-view"
  key={activeProduct.id}
  >
  
  <div className="product-image">
  
  <img
  
  src={activeProduct.image}
  
  alt={activeProduct.name}
  
  />
  
  </div>
  
  <div className="product-information">
  
  <span>
  
  {activeProduct.category}
  
  </span>
  
  <h2>
  
  {activeProduct.name}
  
  </h2>
  
  <p>
  
  {activeProduct.description}
  
  </p>
  
  <div className="product-divider"></div>

  <div className="details-grid">

<div className="details-card">

    <h3>

        Key Features

    </h3>

    <ul>

        {

            activeProduct.features.map((feature,index)=>(

                <li key={index}>

                    <FaCheckCircle />

                    <span>

                        {feature}

                    </span>

                </li>

            ))

        }

    </ul>

</div>

<div className="details-card">

    <h3>

        Applications

    </h3>

    <div className="application-list">

        {

            activeProduct.applications.map((application,index)=>(

                <span
                    key={index}
                    className="application-tag"
                >

                    {application}

                </span>

            ))

        }

    </div>

</div>

</div>

<div className="product-actions">

<a
    href="#contact"
    className="btn-primary-custom"
>

    Request Quote

</a>

<a
    href="#contact"
    className="btn-outline-custom"
>

    Talk To Expert

</a>

</div>

</div>

</div>

</div>

</div>

</section>

);

}

export default ProductShowcase;